export const _ADD               = "IE3qLZal3wGJmuTQFydAPw==";
export const _EDIT              = "Jxm2WiQeDMduT7N96e6MyQ==";
export const _VIEW              = "XbCOy6zSHEUh4wiDzHrQ4Q==";
export const _DELETE            = "pLk6y2hnXqNzWpGLYoo9UA==";
export const _RECOVER           = "ZlCnFO6sl3jqlf45V3fepd7RJbqTPU3Vt+BauxU5NDo=";
export const _LIST              = "ntiQmHG0A0tJvTR4LKmLFg==";
export const _TRASH             = "Ue4NYiSmQxi5OcobtkeRFw==";